<!-- *ngIf="!isPebbRetireeVision && !isCobraOE && !isPebbCobraInitial && !isPebbCobraSOE && !(selfPay.isPEBB && selfPay.isRetireeSOE)" -->
<form nativeControlElement #dependentForm="ngForm" #formContainer>
  <ng-container *ngTemplateOutlet="demographics"></ng-container>
  
  <ng-container *ngIf="selfPay.isRetireeOE || selfPay.isPebbCOBRA || selfPay.isSebbCobraOE || selfPay.isSebbCobraSOE">
    <ng-container *ngTemplateOutlet="coverage"></ng-container>
    <ng-container *ngIf="selfPay.isPebbCobraInitial">
      <ng-container *ngTemplateOutlet="socialSecurityDisability"></ng-container>
      <ng-container *ngTemplateOutlet="medicare"></ng-container>
    </ng-container>
    <ng-container *ngIf="!selfPay.isPebbCobraInitial">
      <ng-container *ngTemplateOutlet="medicare"></ng-container>
      <ng-container *ngTemplateOutlet="socialSecurityDisability"></ng-container>
    </ng-container>
    <ng-container *ngIf="selfPay.isSebbCobraOE">
      <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!selfPay.isRetireeOE && !selfPay.isPebbCOBRA && !selfPay.isSebbCobraOE && !selfPay.isSebbCobraSOE">
    <ng-container *ngTemplateOutlet="medicare"></ng-container>
    <ng-container *ngIf="!selfPay.isLWOP">
      <ng-container *ngTemplateOutlet="socialSecurityDisability"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="coverage"></ng-container>
    <ng-container *ngIf="selfPay.isLWOP">
      <ng-container *ngTemplateOutlet="socialSecurityDisability"></ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngTemplateOutlet="tobacco"></ng-container>

  <ng-container *ngTemplateOutlet="spousal"></ng-container>

  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between">
    <button fxFlex="30" (click)="cancelChanges()" class="btn btn-light">Cancel</button>
    <button fxFlex="30" [disabled]="!isAdd && !currentDependent.confirmed && selfPay?.isPebbCobraInitial" (click)="emitSubmitDependent(formContainer)" class="btn btn-primary">Save changes</button>
  </div>

  <div fxLayout="row" fxLayoutAlign="space-between" *ngIf="!isAdd && selfPay?.isPebbCobraInitial">
    <div></div>
    <div fxLayout="column" fxFlex="30">
      <div *ngIf="currentDependent.terminateAllCoverageInd">
        <b>
          You have not elected any coverage for this dependent and they will be terminated from existing coverage(s) at
          the end of the current calendar/plan year (if currently covered).
        </b>
      </div>
      <div class="k-form-field bigger">
        <checkbox name="confirmContinue{{idx}}" [(ngModel)]="currentDependent.confirmed">Confirm to continue
        </checkbox>
      </div>
    </div>
  </div>

  <!-- NOTE: Templates need to stay inside the <form> element, otherwise validation breaks (ngForm is missing controls outside of <form>)-->
  <ng-template #demographics>
    <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
      <div class="form-group" fxFlex="25">
        <label [for]="'socialSecurityNumber' + idx">SSN</label>
        <input [disabled]="!isAdd" #ssn="ngModel" type="text" class="form-control" minlength="11" maxlength="11"
          [ngModel]="(!noSSN ? currentDependent.socialSecurityNumber : null) | ssn"
          (ngModelChange)="currentDependent.socialSecurityNumber = $event?.split('-').join('')"
          [name]="'socialSecurityNumber' + idx" [id]="'socialSecurityNumber' + idx" />
        <!-- One half of the demographics code in add spouse had this instead; all other 5 instances used the above -->
        <!-- <kendo-maskedtextbox [mask]="env.ssnMask" [pattern]="env.ssnItinRegex"
            [(ngModel)]="currentSpouse.socialSecurityNumber" [maskOnFocus]="true"
            [name]="'socialSecurityNumber' + idx" #ssn="ngModel" class="form-control"
            [forbiddenValues]="env.invalidSSNValues"></kendo-maskedtextbox> -->
      </div>
      <div class="form-group" fxFlex="25">
        <date-picker #birthDate="ngModel" [name]="'birthDate' + idx" label="Birth date"
          [(ngModel)]="currentDependent.birthDate" required></date-picker>
      </div>
      <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
        <label class="k-label">Sex assigned at birth<sup>1</sup></label>
        <radio-list [name]="'birthSex' + idx" [(ngModel)]="currentDependent.birthSex"
          [items]="{ Male: 'M', Female: 'F' }" required></radio-list>
      </kendo-formfield>
    </div>
    <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
      <div class="form-group" fxFlex="50">
        <label [for]="'lastName' + idx">Last Name</label>
        <input type="text" class="form-control" [name]="'lastName' + idx" [id]="'lastName' + idx"
          [(ngModel)]="currentDependent.lastName" required />
      </div>
      <kendo-formfield *ngIf="!genderIdentityDisabled" [orientation]="'horizontal'" fxFlex="40">
        <label class="k-label">Gender Identity<sup>2</sup></label>
        <radio-list [name]="'genderIdentity' + idx" [(ngModel)]="currentDependent.genderIdentity"
          [items]="{ Male: 'M', Female: 'F', X: 'X' }"></radio-list>
      </kendo-formfield>
    </div>
    <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
      <div class="form-group" fxFlex="50">
        <label [for]="'firstName' + idx">First Name</label>
        <input type="text" class="form-control" [id]="'firstName' + idx" [name]="'firstName' + idx"
          [(ngModel)]="currentDependent.firstName" required />
      </div>
      <div class="form-group" fxFlex="15">
        <label [for]="'middleInitial' + idx">Middle Initial</label>
        <input type="text" class="form-control" [id]="'middleInitial' + idx" [name]="'middleInitial' + idx"
          [(ngModel)]="currentDependent.middleName" />
      </div>
      <div class="form-group" fxFlex="15">
        <label [for]="'suffix' + idx">Suffix</label>
        <input type="text" class="form-control" [id]="'suffix' + idx" [name]="'suffix' + idx"
          [(ngModel)]="currentDependent.suffix" />
      </div>
    </div>
    <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill *ngIf="!isAdd && currentDependent.isSpouse">
      <div class="form-group" fxFlex="25">
        <date-picker #dateOfMarriage="ngModel" [name]="'dateOfMarriage' + idx" label="Date of marriage/Partnership date"
          [(ngModel)]="currentDependent.partnershipStartDate"></date-picker>
      </div>
    </div>
    <checkbox bold name="addressSameAsSubscriber{{idx}}" [(ngModel)]="currentDependent.addressSameAsSubscriber">
      {{ selfPay.isPebbLwopOE ? 'Street' : (selfPay.isLwopInitial || selfPay.isPebbCobraOE || selfPay.isPebbCobraInitial) ? 'Permanent street' : 'Residential' }}
      address is the same as subscriber
    </checkbox>
    <div class="form-row" *ngIf="!currentDependent.addressSameAsSubscriber">
      <address #residentialAddress view="inline" name="residentialAddress"
        [hideCounty]="true"
        [hideCountry]="true"
        [(ngModel)]="currentDependent.residentialAddress"></address>
      <div *ngIf="selfPay.isRetireeOE">
        PO Box is not allowed for Medicare enrollment. 
      </div>
      <div *ngIf="selfPay.isPebbLwopOE && selfPay.PebbLwopSOE" style="margin-bottom: 20px;">
        Enrollment in Medicare Advantage Plans (MAPD) or Medicare Part D has specific requirements associated with
        residential addresses.
        PO boxes and out-of-country addresses may not be eligible for MAPD/Part D enrollment and will need to be reviewed
        by HCA for eligibility.
        Proof of residence may need to be provided.
      </div>
      <div *ngIf="selfPay.isPebbCobraOE || selfPay.isPebbCobraInitial" style="margin-bottom: 20px;">
        PO Box not allowed.
      </div>
      <div style="margin-bottom: 20px;" *ngIf="selfPay.isRetireeInitial || selfPay.isSebbCobraOE || selfPay.isPebbCOBRA">
        Enrollment in a Medicare supplement plan, a Medicare Advantage with Part D plan<ng-container *ngIf="!selfPay.isPebbCobraInitial"> (MAPD)</ng-container>, or UMP Classic Medicare with Part D (PDP)
        has specific requirements associated with permanent residential addresses. PO boxes and out-of-country addresses will be
        reviewed by HCA for eligibility. Proof of permanent residence in the United States may need to be provided to determine you
        and your dependent reside in the health plan service area.
      </div>
      <div style="margin-bottom: 20px;" *ngIf="selfPay.isRetireeSOE">
        If you are enrolled in Medicare, this information needs to match your Medicare record to avoid delay to coverage
        starting.
        Proof of address may need to be provided.
      </div>
    </div>

    <div class="form-row" fxFlexFill>
      <div fxLayout="column" fxFlex="100">
        <div class="hca-selfPay-divider" fxFlex="45"></div>
        <span class="hca-selfPay-small-note" fxFlex="100"> 1. This field is required for health care services. </span>
        <span class="hca-selfPay-small-note" fxFlex="100" *ngIf="!genderIdentityDisabled">
          2. This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. 
          Gender X means a gender that is not exclusively male nor female. To learn more visit 
          <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X</a>.
          <br/><br/>
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #socialSecurityDisability>
    <div
      *ngIf="selfPay.isCOBRA || selfPay.isSebbLWOP"
      fxLayout="row" fxFlexFill>
      <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
        <label class="k-label">Does this person receive Social Security Disability?</label>
        <yes-no [name]="'coveredByOtherSSD' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
          [(ngModel)]="currentDependent.coveredByOtherSSDInd"></yes-no>
      </kendo-formfield>
      <div class="form-inline">
        <date-picker #coveredByOtherSSDDate="ngModel" [name]="'coveredByOtherSSDDate' + idx"
          [(ngModel)]="currentDependent.coveredByOtherSSDDate">
          <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
        </date-picker>
      </div>
    </div>
    <h4 *ngIf="!selfPay.isSebbCobraOE && (selfPay.isCobraInitial || selfPay.isPebbCobraOE || selfPay.isSebbLwopInitial || selfPay.isSebbLwopOE)">
      <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
      If you answered Yes to receiving Social Security Disability, you must upload or send a copy of your Social
      Security Disability Award letter. If mailing, write your last name and the last four digits of
      your Social Security number on the copy so we can identify your account. You and your enrolled dependents may be
      eligible for additional months of coverage.
    </h4>
    <h4 *ngIf="selfPay.isSebbCobraOE">
      <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
      If Yes, upload or mail a copy of their Social Security Disability Award letter. Write your full name and the last four digits of your
      Social Security number on the copy. You and your enrolled dependents may be eligible for additional months of coverage.
    </h4>
  </ng-template>

  <ng-template #otherCoverageSection>
    <ng-container *ngIf="!selfPay.isSebbCobraInitial && !selfPay.isSebbCobraOE">
      <div *ngIf="(selfPay.isCobraOE && !isAdd) || selfPay.isPebbCobraSOE" fxLayout="row" fxFlexFill>
        <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
          <label class="k-label">Are you covered by another group medical plan?</label>
          <yes-no [name]="'coveredByOtherMedical' + idx" style="width: auto;" orientation="horizontal-list"
            [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherMedicalInd"></yes-no>
        </kendo-formfield>
        <div class="form-inline">
          <date-picker #coveredByOtherMedicalDate="ngModel" [name]="'coveredByOtherMedicalDate' + idx"
            [(ngModel)]="currentDependent.coveredByOtherMedicalDate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
          </date-picker>
        </div>
      </div>
      <div *ngIf="(selfPay.isCobraOE && !isAdd) || selfPay.isPebbCobraSOE" fxLayout="row" fxFlexFill>
        <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
          <label class="k-label">Are you covered by another group dental plan?</label>
          <yes-no [name]="'coveredByOtherDental' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
            [(ngModel)]="currentDependent.coveredByOtherDentalInd"></yes-no>
        </kendo-formfield>
        <div class="form-inline">
          <date-picker #coveredByOtherDentalDate="ngModel" [name]="'coveredByOtherDentalDate' + idx"
            [(ngModel)]="currentDependent.coveredByOtherDentalDate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
          </date-picker>
        </div>
      </div>
      <div *ngIf="(selfPay.isCobraOE && !isAdd) || selfPay.isPebbCobraSOE" fxLayout="row" fxFlexFill>
        <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
          <label class="k-label">Are you covered by another group vision plan?</label>
          <yes-no [name]="'coveredByOtherVision' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
            [(ngModel)]="currentDependent.coveredByOtherVisionInd"></yes-no>
        </kendo-formfield>
        <div class="form-inline">
          <date-picker #coveredByOtherVisionDate="ngModel" [name]="'coveredByOtherVisionDate' + idx"
            [(ngModel)]="currentDependent.coveredByOtherVisionDate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
          </date-picker>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #coverage>
    <div *ngIf="(selfPay.isLWOP && !isAdd) || (selfPay.isSebbCobraSOE && !isAdd) || (selfPay.isSebbCobraInitial && !isAdd)">
      <div class="form-row" style="padding-top: 20px" fxFlexFill>
        <h3 class="mobile-text-centered">Choose one box for each type of coverage</h3>
      </div>
      <div class="form-row" fxFlexFill>
        <div class="form-row" fxFlexFill style="margin-bottom: 20px">
          <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
            <span class="soe-form-small-header">Medical coverage (Select all that apply)</span>
            <div>You may choose to continue coverage and then terminate it at a future date by selecting to both continue
              and terminate coverage and providing a termination date and reason below.</div>
            <div fxLayout="row">
              <div fxLayout="column" fxFlex="50">
                <checkbox (change)="updateCoverageContinue($event, 'medicalDoNotContinueCoverage')"
                  [name]="'continueMedical' + idx" [required]="!currentDependent.medicalDoNotContinueCoverage"
                  [(ngModel)]="currentDependent.medicalContinueCoverageInd" label="Continue coverage"></checkbox>
                <checkbox [name]="'termMedical' + idx" [(ngModel)]="currentDependent.medicalTerminateCoverage"
                  label="Terminate coverage"></checkbox>
              </div>
              <div fxLayout="column" fxFlex="50">
                <checkbox [name]="'doNotContinueMedical' + idx"
                  [required]="!currentDependent.medicalDoNotContinueCoverage && !currentDependent.medicalContinueCoverageInd"
                  [(ngModel)]="currentDependent.medicalDoNotContinueCoverage" label="Do not continue coverage"
                  (change)="updateCoverageContinue($event, 'medicalContinueCoverageInd')">
                </checkbox>
                <div class="form-inline" style="margin: 15px 15px 0px 0px">
                  <date-picker #medicalTerminateCoverageDate="ngModel" [name]="'medicalTerminateCoverageDate' + idx"
                    [required]="currentDependent.medicalTerminateCoverage"
                    [(ngModel)]="currentDependent.medicalTerminateCoverageDate">
                  </date-picker>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxFlexFill>
              <div [class.required]="currentDependent.medicalTerminateCoverage" class="form-group" fxFlex="100"
                style="margin-right: 15px">
                <label [for]="'medicalTermReason' + idx">If terminating coverage, include reason</label>
                <input [required]="currentDependent.medicalTerminateCoverage" type="text" class="form-control"
                  [id]="'medicalTermReason' + idx" [name]="'medicalTermReason' + idx"
                  [(ngModel)]="currentDependent.medicalTerminateCoverageReason" />
              </div>
            </div>
          </div>
          <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
            <span class="soe-form-small-header">Dental coverage</span>
            <div fxLayout="row">
              <div fxLayout="column" fxFlex="50">
                <checkbox [name]="'continueDental' + idx" [required]="!currentDependent.dentalDoNotContinueCoverage"
                  (change)="updateCoverageContinue($event, 'dentalDoNotContinueCoverage')"
                  [(ngModel)]="currentDependent.dentalContinueCoverageInd" label="Continue coverage">
                </checkbox>
                <checkbox [name]="'termDental' + idx" [(ngModel)]="currentDependent.dentalTerminateCoverage"
                  label="Terminate coverage"></checkbox>
              </div>
              <div fxLayout="column" fxFlex="50">
                <checkbox [name]="'doNotContinueDental' + idx"
                  [required]="!currentDependent.dentalDoNotContinueCoverage && !currentDependent.dentalContinueCoverageInd"
                  (change)="updateCoverageContinue($event, 'dentalContinueCoverageInd')"
                  [(ngModel)]="currentDependent.dentalDoNotContinueCoverage" label="Do not continue coverage">
                </checkbox>
                <div class="form-inline" style="margin: 15px 15px 0px 0px">
                  <date-picker #dentalTerminateCoverageDate="ngModel" [name]="'dentalTerminateCoverageDate' + idx"
                    [required]="currentDependent.dentalTerminateCoverage"
                    [(ngModel)]="currentDependent.dentalTerminateCoverageDate">
                  </date-picker>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxFlexFill>
              <div [class.required]="currentDependent.medicalTerminateCoverage" class="form-group" fxFlex="100"
                style="margin-right: 15px">
                <label [for]="'dentalTermReason' + idx">If terminating coverage, include reason</label>
                <input [required]="currentDependent.dentalTerminateCoverage" type="text" class="form-control"
                  [id]="'dentalTermReason' + idx" [name]="'dentalTermReason' + idx"
                  [(ngModel)]="currentDependent.dentalTerminateCoverageReason" />
              </div>
            </div>
          </div>
          <h4>
            <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
            If you terminate all coverage, you will not be eligible to enroll again in {{agency}} Continuation Coverage
            unless you regain eligibility.
          </h4>
        </div>
        <div fxLayout="column" fxFlex="100" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <span class="soe-form-small-header">Vision coverage</span>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="100">
              <checkbox [name]="'continueVision' + idx" [required]="!currentDependent.visionDoNotContinueCoverage"
                (change)="updateCoverageContinue($event, 'visionDoNotContinueCoverage')"
                [(ngModel)]="currentDependent.visionContinueCoverageInd" label="Continue coverage">
              </checkbox>
              <checkbox [name]="'termVision' + idx" [(ngModel)]="currentDependent.visionTerminateCoverage"
                label="Terminate coverage"></checkbox>
            </div>
            <div fxLayout="column" fxFlex="50">
              <checkbox [name]="'doNotContinueVision' + idx"
                [required]="!currentDependent.visionDoNotContinueCoverage && !currentDependent.visionContinueCoverageInd"
                (change)="updateCoverageContinue($event, 'visionContinueCoverageInd')"
                [(ngModel)]="currentDependent.visionDoNotContinueCoverage" label="Do not continue coverage">
              </checkbox>
              <div class="form-inline" style="margin: 15px 15px 0px 0px">
                <date-picker #visionTerminateCoverageDate="ngModel" [name]="'visionTerminateCoverageDate' + idx"
                  [required]="currentDependent.visionTerminateCoverage"
                  [(ngModel)]="currentDependent.visionTerminateCoverageDate">
                </date-picker>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlexFill>
            <div class="form-group" fxFlex="100" style="margin-right: 15px">
              <label [class.required]="currentDependent.visionTerminateCoverage" for="visionTermReason">If terminating
                coverage,
                include reason</label>
              <input [required]="currentDependent.visionTerminateCoverage" type="text" class="form-control"
                name="visionTermReason" [(ngModel)]="currentDependent.visionTerminateCoverageReason" />
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
      </div>
    </div>

    <div *ngIf="!selfPay.isRetireeInitial && !selfPay.isSebbCobraOE && (selfPay.isRetiree || selfPay.isPebbCOBRA)">
      <div class="form-row" style="padding-top: 20px" fxFlexFill>
        <h4>Coverage options</h4>
        <span class="soe-form-small-header">Enroll dependent in (or remain enrolled)</span>
      </div>
      <div class="form-row" fxFlexFill>
        <div>
          <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px"
              class="fxGap-medium-sm">
              <div class="k-form-field bigger" fxFlex="30">
                <checkbox name="medicalEnrollInd" [(ngModel)]="currentDependent.medicalCoverInd"
                  (ngModelChange)="handleMedicalEnrollChange($event)">Medical</checkbox>
              </div>
              <div class="k-form-field bigger" fxFlex="30">
                <checkbox name="dentalEnrollInd" [(ngModel)]="currentDependent.dentalCoverInd"
                  (ngModelChange)="currentDependent.terminateAllCoverageInd = false">Dental
                </checkbox>
              </div>
              <div class="k-form-field bigger" fxFlex="30">
                <checkbox name="visionEnrollInd" [(ngModel)]="currentDependent.visionCoverInd"
                  (ngModelChange)="currentDependent.terminateAllCoverageInd = false" [disabled]="(!isSebbCobra && currentDependent.medicarePartBInd)">
                  Vision</checkbox>
              </div>
            </div>
          </div>
          <div *ngIf="selfPay.isRetiree" fxLayout="column" fxFlex="50"
            fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
              <span *ngIf="selfPay.isRetireeOE">
                Dependents will be enrolled in the same coverage as you (the subscriber). The exceptions are:
                <br />
                <br />
                <ol>
                  <li>
                    The standalone vision option is available for non-Medicare enrolled dependents if subscriber is enrolled in Medicare
                  </li>
                  <li *ngIf="selfPay.isRetireeOE">
                    If you are deferring due to Medicare/Medicaid, your dependent can enroll (or remain enrolled) in coverage you aren't enrolled in if they are not eligible for creditable coverage under Medicaid.
                  </li>
                  <li *ngIf="!selfPay.isRetireeOE">
                    If you are deferring due to Medicare/Medicaid, your dependent can enroll in coverage you aren't enrolled in.
                  </li>
                </ol>
                <br />
                <div *ngIf="selfPay.isRetireeOE">
                  Coverage that is terminated will end December 31 of the current year. If you are enrolled in a Medicare Advantage with Part D
                  plan or the UMP Classic Medicare with Part D (PDP) you must also submit 
                  <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">
                    Form D
                  </a>
                </div>
                <div *ngIf="!selfPay.isRetireeOE">
                  Coverage that is terminated will end December 31 of the current year and could require additional
                  forms to be submitted if enrolled in a Medicare Advantage (MA) or Medicare Advantage Prescription Drug
                  Plan (MAPD). Also submit
                  <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">
                    Form D
                  </a>
                </div>
              </span>
              <span *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeSOE">
                Dependents can only be enrolled in the same coverages that are elected for the subscriber. The exceptions
                are:
                <br />
                <br />
                <ol>
                  <li>Standalone vision coverage is available for non-Medicare enrolled dependents if subscriber is
                    enrolled in Medicare.</li>
                  <li>
                    <p>
                      If subscriber is deferring due to Medicare/Medicaid, the dependent can enroll in coverages the
                      subscriber isn't also enrolled in.
                    </p>
                    <p>
                      Coverage that is terminated will end at the end of the current calendar/plan year and could require
                      additional forms to be submitted if
                      enrolled in a Medicare Advantage (MA), Medicare Advantage Prescription Drug Plan (MAPD) or a Part D
                      plan.
                    </p>
                  </li>
                </ol>
                Response required if your are enrolling dependents age 13 and older in medical coverage. If you check Yes
                or do not check any boxes below,
                you will be charged the $25-per-account premium surcharge in addition to your monthly medical premium.
              </span>
            </div>
          </div>
          <div *ngIf="selfPay.isSebbCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
            fxLayoutAlign="space-between" class="fxGap-small">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
              <span>
                Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to terminate
                an existing
                coverage, deselect the coverage and it will end on December 31 of the current year.
              </span>
            </div>
          </div>
          <div *ngIf="selfPay.isPebbCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
            fxLayoutAlign="space-between" class="fxGap-small">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
              <span>
                <p>
                  Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to
                  terminate existing coverage,
                  deselect the coverage and it will end on December 31 of the current year.
                </p>
                <p>
                  Termination of coverage from a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) also requires a 
                  <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">PEBB Medicare Plan Disenrollment form (form D)</a>
                </p>
              </span>
            </div>
          </div>
          <div *ngIf="selfPay.isPebbCobraInitial || selfPay.isPebbCobraSOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
            fxLayoutAlign="space-between" class="fxGap-small">
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
              <span>
                Choose the coverage you wish to enroll this dependent in (or remain enrolled in). 
                <br />
                <br />
                <p *ngIf="!selfPay.isPebbCobraInitial">
                  Terminating coverage from a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) also 
                  <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">requires a PEBB Medicare Plan Disenrollment form (form D)</a>
                </p>
              </span>
            </div>
          </div>
        </div>
        <div class="form-row" fxFlexFill style="margin-bottom: 20px" *ngIf="selfPay.isPebbCobraSOE">
          Enrollment in Medicare Advantage Plans (MAPD) or Medicare Part D has specific requirements associated with
          residential addresses.
          PO boxes and out-of-country addresses may not be eligible for MAPD/Part D enrollment and will need to be
          reviewed
          by HCA for eligibility.
          Proof of residence may need to be provided.
        </div>

        <div class="form-row" fxFlexFill *ngIf="selfPay.isPebbCOBRA && !isAdd">
          <div fxLayout="column" fxFlexFill>
            <span class="soe-form-small-header">Terminate coverage (Select all that apply)</span>
            <div>
              You may choose to continue coverage and then terminate it at a future date by selecting to both continue and
              terminate coverage and providing a termination date and reason below.
            </div>
            <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
              <div class="k-form-field bigger">
                <checkbox name="medicalTerminateCoverage" [(ngModel)]="currentDependent.medicalTerminateCoverage">Medical
                </checkbox>
              </div>
              <div class="k-form-field bigger">
                <checkbox name="dentalTerminateCoverage" [(ngModel)]="currentDependent.dentalTerminateCoverage">Dental
                </checkbox>
              </div>
              <div class="k-form-field bigger">
                <checkbox name="visionTerminateCoverage" [(ngModel)]="currentDependent.visionTerminateCoverage">Vision
                </checkbox>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
              <div class="form-group" fxFlex="25">
                <date-picker #terminationDate="ngModel" name="terminationDate" label="Termination date"
                  [required]="currentDependent.medicalTerminateCoverage || currentDependent.dentalTerminateCoverage || currentDependent.terminateLifeAndADDCoverageInd"
                  onlyAllowLastOfMonth [(ngModel)]="currentDependent.terminateAllCoverageDate" 
                  (ngModelChange)="setCurrentDependentTerminateAll()"></date-picker>
              </div>
              <div class="form-group" fxFlex="70">
                <label for="ultermreason">Term Reason</label>
                <input
                  [required]="currentDependent.medicalTerminateCoverage || currentDependent.dentalTerminateCoverage || currentDependent.terminateLifeAndADDCoverageInd"
                  type="text" class="form-control" name="ultermreason" id="ultermreason"
                  [(ngModel)]="currentDependent.terminateAllCoverageReason" />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
      </div>

      <div class="form-row" fxFlexFill *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeSOE || (selfPay.isCobraOE && !isAdd)">
        <div>
          <div fxLayout="row" fxFlex="100">
            <div fxLayout="row" [fxFlex]="!selfPay.isPebbRetireeSOE ? 100 : 30" fxLayoutAlign="start center" class="fxGap-medium-sm"
              style="margin-bottom: 20px">
              <div class="k-form-field bigger" fxFlex="100">
                <checkbox name="deferCoverageInd" [disabled]="currentDependent.actionsCode === 'deferring'"
                  [(ngModel)]="currentDependent.terminateAllCoverageInd"
                  (ngModelChange)="terminateAllCoveragesChange($event)">Terminate all coverage(s)</checkbox>
              </div>
            </div>
            <div class="form-inline" fxFlex="30" *ngIf="selfPay.isPebbRetireeSOE">
              <div class="form-group">
                <date-picker #terminateAllCoverageDate="ngModel" name="terminateAllCoverageDate"
                  [required]="currentDependent.terminateAllCoverageInd"
                  [(ngModel)]="currentDependent.terminateAllCoverageDate">
                  <span style="white-space: nowrap; margin-right: 20px">Termination date</span>
                </date-picker>
              </div>
            </div>
            <div class="form-inline" fxFlex="30" *ngIf="selfPay.isPebbRetireeSOE">
              I understand by terminating coverage I am forfeiting all further rights to enroll again unless I regain
              eligibility. I understand I must also submit a PEBB Medicare Advantage Plan Disenrollment Form (form D) ir
              I or an enrolled dependent is in an Medicare Advantage Plan or Medicare Part D.
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="selfPay.isSebbCobraOE || ((selfPay.isLWOP || selfPay.isSebbCobraInitial || selfPay.isSebbCobraSOE) && isAdd)">
      <ng-container *ngIf="!selfPay.isSebbCobraOE">
        <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
      </ng-container> 

      <div>
        <div class="form-row" style="padding-top: 20px" fxFlexFill>
          <h3 class="mobile-text-centered">Choose one box for each type of coverage</h3>
        </div>
        <div class="form-row" fxFlexFill style="margin-bottom: 20px">
          <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
            <span class="selfPay-form-small-header">Medical coverage</span>
            <radio [name]="'medicalCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.medicalCoverInd"
              [value]="true" label="Cover"></radio>
            <radio [name]="'medicalCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.medicalCoverInd"
              [value]="false" label="Remove from coverage"></radio>
          </div>
          <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
            <span class="selfPay-form-small-header">Dental coverage</span>
            <radio [name]="'dentalCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.dentalCoverInd"
              [value]="true" label="Cover"></radio>
            <radio [name]="'dentalCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.dentalCoverInd"
              [value]="false" label="Remove from coverage"></radio>
          </div>
        </div>
        <div class="form-row" fxFlexFill style="margin-bottom: 20px">
          <div fxLayout="column" fxFlex="100" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
            <span class="selfPay-form-small-header">Vision coverage</span>
            <radio [name]="'visionCoverYes' + idx" radioAsCheckbox [(ngModel)]="currentDependent.visionCoverInd"
              [value]="true" label="Cover"></radio>
            <radio [name]="'visionCoverNo' + idx" radioAsCheckbox [(ngModel)]="currentDependent.visionCoverInd"
              [value]="false" label="Remove from coverage"></radio>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeSOE">
      <div class="form-row" fxFlexFill>
        <span class="selfPay-form-small-header">I want to enroll this dependent in</span>
        <div fxFlexFill style="margin-bottom: 20px">
          <p>
            By choosing to enroll into coverage for yourself, your dependent(s) are automatically enrolled in the same plan
            as you, with some exceptions based on eligibility for Medicare Part A and Part B.
          </p>
          <ng-container *ngIf="selfPay.isRetireeInitial">
            <p>The exceptions are:</p>
            <ol>
              <li>The standalone vision option is available for non-Medicare enrolled dependents if subscriber is enrolled in Medicare.</li>
              <li>
                If you are deferring due to Medicare/Medicaid, your dependent can enroll (or remain enrolled) in coverage you aren't enrolled in if they
                are not eligible for creditable coverage under Medicaid.
              </li>
            </ol>
          </ng-container>
        </div>
      </div>
      <div class="form-row" fxFlexFill style="margin-bottom: 20px">
        <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
          <checkbox [name]="'medicalCover' + idx" [(ngModel)]="currentDependent.medicalCoverInd" label="Medical">
          </checkbox>
        </div>
        <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
          <checkbox [name]="'dentalCover' + idx" [(ngModel)]="currentDependent.dentalCoverInd" label="Dental"></checkbox>
        </div>
        <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between">
          <checkbox [name]="'visionCover' + idx" [(ngModel)]="currentDependent.visionCoverInd" label="Vision" [disabled]="currentDependent.medicarePartBInd"></checkbox>
        </div>
      </div>
    </ng-container>
    
    <div *ngIf="!selfPay.isRetireeInitial && !selfPay.isPebbCobraInitial && !(selfPay.isCobraOE && isAdd) && !(selfPay.isCobraSOE && isAdd) && selfPay.medicareAvailable" fxLayoutAlign="row">
      <fa-icon fxFlex="5" [icon]="icons.faExclamationCircle" color="primary" size="1x"></fa-icon>
      <span>Premium surcharges do not apply if subscriber is enrolled in Medicare Part A and Part B</span>
    </div>
  </ng-template>

  <ng-template #spousal>
    <div *ngIf="currentDependent.isSpouse" class="form-row"
      fxFlexFill style="margin-bottom: 20px">
      <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
        <span class="selfPay-form-small-header">Spouse or state-registered domestic partner (SRDP) coverage premium surcharge </span>
        <span style="padding-bottom: 10px">
          Response required if you are enrolling your spouse or SRDP in medical coverage. The {{agency}} Program requires
          a $50 premium surcharge in addition to your monthly medical premium if you are
          enrolling your spouse or SRDP in {{agency}} medical and they have chosen not to enroll in another employer-based
          group medical that is comparable to PEBB's Uniform Medical Plan Classic.
          <div *ngIf="selfPay.isPebbLwopOE || selfPay.isPebbLwopInitial || selfPay.isSebbCobraInitial || selfPay.isSebbLwopInitial">
            <br/>
            <a target="_blank" [href]="spousalSurchargeLink(selfPay)">Learn about this surcharge</a> before you make your attestation.
            <br/><br/>
            <ng-container *ngIf="selfPay.isPebbCobraOE || selfPay.isPebbCobraInitial">
              Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B. 
            </ng-container>
          </div>
          <br />
          <br />
          <b>Answer these questions for your spouse or SRDP in {{coverageYear}}:</b>
          <div fxLayout="column">
            <ol class="hca-ordered-list">
              <li><yes-no name="spouseAttestQ1" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ1" (change)="spousalChange(currentDependent)">
                  Are you covering your spouse or SRDP in a {{agency}} medical plan?
                </yes-no></li>
              <li><yes-no name="spouseAttestQ2" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ2" (change)="spousalChange(currentDependent)">
                  Will they be eligible for medical coverage through their employer? (If they will not
                  be employed, answer No.)
                </yes-no></li>
              <li><yes-no name="spouseAttestQ3" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ3" (change)="spousalChange(currentDependent)">
                  Will their employer offer at least one medical plan that serves their county of residence?
                </yes-no></li>
              <li><yes-no name="spouseAttestQ4" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ4" (change)="spousalChange(currentDependent)">
                  Have they chosen not to enroll in their employer's medical coverage?
                </yes-no></li>
              <li><yes-no name="spouseAttestQ5" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ5" (change)="spousalChange(currentDependent)">
                  Will the coverage offered by their employer <b>not</b> be through the PEBB Program, SEBB Program, or a TRICARE plan?<br/> 
                      Answer Yes if their employer does <b>not</b> offer PEBB or SEBB coverage, or a TRICARE plan. <br/>
                      Answer No if their employer offers PEBB or SEBB coverage, or a TRICARE plan.
                </yes-no></li>
              <li><yes-no name="spouseAttestQ6" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                  [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                  [(ngModel)]="currentDependent.spouseAttestQ6" (change)="spousalChange(currentDependent)">
                  Will their share of the medical premium through their employer be less than ${{ spousalRate(coverageYear)}} per month?
                </yes-no></li>
            </ol>
          </div>
          If you answered No to any of these questions, check no below. You will not be charged the surcharge.
          If you answered Yes to all {{ selfPay.isPebbCobraOE ? '' : 'of' }} these questions:
          <br />
          <br />
          <ol>
            <li>Ask your spouse or SRDP for the Summary of Benefits and Coverage (SBC) for all medical plans that:
              <ol type="a">
                <li>Serve their county of residence.</li>
                <li>Have a monthly premium of less than ${{ spousalRate(coverageYear)}} per month for the employee.</li>
              </ol>

            </li>
            <li>Use the SBC information to answer the questions in the {{agency}} Spousal Plan Calculator online tool. You
              will get a Yes or No response from the calculator. Enter your response below.</li>
          </ol>
          <br />
          <b>Does the spouse or SRDP coverage premium surcharge apply to you?</b> Check one:
        </span>

        <span class="selfPay-form-small-header" fxFlex="40">
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you check <b>Yes</b> or do not check any boxes below, you will be charged the $50 spouse or SRDP coverage premium surcharge.
        </span>

        <radio *ngIf="selfPay.medicareAvailable" [name]="'spouseSurchargeNAMedicare' + idx" radioAsCheckbox
            [disabled]="currentDependent.surchargeNA" value="NAMedicare"
            [(ngModel)]="currentDependent.spouseSurchargeTriState">
            No, the subscriber is enrolled in Medicare Part A and Part B. The premium surcharge does not apply.
        </radio>
        <radio [name]="'spousalNo' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="N"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          <b>No,</b> I am not subject to the $50 premium surcharge. If needed, I completed the {{agency}} Spousal Plan Calculator online.
        </radio>
        <div fxlayout="row" fxFlex="100" fxLayoutAlign="space-between">
          <radio [name]="'spousalYes' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="Y"
            [(ngModel)]="currentDependent.spouseSurchargeTriState">
            <b>Yes,</b> I am subject to the $50 premium surcharge. I completed the 
            <a [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/spousal-plan-calculator' : 'https://www.hca.wa.gov/employee-retiree-benefits/spousal-plan-calculator'"
              target="_blank">{{agency}} Spousal Plan Calculator</a> online.
          </radio>
        </div>
        <radio [name]="'spousalHelp' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="H"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          The {{agency}} Program to help determine if premium surcharge applies. I am completing and submitting a printed
          {{agency}} Spousal Plan Calculator.
        </radio>
      </div>
    </div>
  </ng-template>

  <ng-template #tobacco>
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <div *ngIf="currentDependent.birthDate < thirteenYearsDate" fxLayout="column" fxFlex="100"
        fxLayoutAlign="space-between">
        <span class="selfPay-form-small-header">Tobacco use premium surcharge</span>
        <span style="padding-bottom: 10px">
          <span *ngIf="currentDependent.isSpouse">
            Response required if you are enrolling your spouse or state-registered domestic partner (SRDP) in medical
            coverage. If you check Yes or do not check any boxes below, you will be charged the
            $25-per-account premium surcharge in addition to your monthly medical premium.
          </span>
          <span *ngIf="!currentDependent.isSpouse">
            Response required if you are enrolling dependents age 13 and older in medical coverage. If you check Yes or do
            not check any boxes below, you will be charged the $25-per-account premium
            surcharge in addition to your monthly medical premium.
          </span>
          <span *ngIf="selfPay.medicareAvailable">
            <br/>
            <br/>
            Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B. 
          </span>
          <ng-container *ngIf="selfPay.isPebbLwopOE">
            <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/tobacco-use-surcharge">Learn about this surcharge before you attest</a>.  
          </ng-container>
          <ng-container *ngIf="selfPay.isSebbLwopOE">
            <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/tobacco-use-surcharge">Learn about this surcharge before you attest</a>.  
          </ng-container>
          <br />
          <br />
          <b>Does the tobacco use premium surcharge apply to you?</b> Check one:
        </span>
        <div *ngIf="selfPay.medicareAvailable" class="k-form-field bigger" style="margin-bottom: 15px">
          <checkbox [name]="'tobaccoNA' + idx" [(ngModel)]="currentDependent.surchargeNA || disableFormForNoCoverage" (change)="updateTobacco()" >
            <b>No, the subscriber</b> is enrolled in Medicare Part A and Part B. Premium surcharge does not apply.
          </checkbox>
        </div>
        <div class="k-form-field bigger" style="margin-bottom: 20px" class="hca-mid-sz">
          <radio [name]="'tobaccoNo' + idx" [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" radioAsCheckbox [value]="false"
            [(ngModel)]="currentDependent.tobaccoUseInd">
            <b>No,</b> I am not subject to the $25 premium surcharge. This dependent has not used tobacco products in the
            past two months or has enrolled in or accessed 
            <span *ngIf="!selfPay.isSEBB && !selfPay.isLwopOE">one of </span>
            <span *ngIf="selfPay.isPEBB && selfPay.isLwopOE">one of the </span>
            <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'"> tobacco cessation
            resources</a><ng-container *ngIf="!currentDependent.isSpouse"> (if age 18 or older) or accessed information or resources on the Smokefree Teen website (if age 13 to 17)</ng-container>.
          </radio>
        </div>
        <div class="k-form-field bigger" style="margin-bottom: 15px">
          <radio [name]="'tobaccoYes' + idx" [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" radioAsCheckbox [value]="true"
            [(ngModel)]="currentDependent.tobaccoUseInd">
            <b>Yes,</b> I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past
            two months.
          </radio>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #medicare>
    <div *ngIf="selfPay?.medicareAvailable || selfPay?.isCOBRA">
      <div class="form-row" fxFlexFill style="margin-bottom: 20px">
        <span class="soe-form-small-header">Medicare Information</span>
        <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
        <div fxLayout="row" fxFlexFill>
          <kendo-formfield [orientation]="'horizontal'" fxFlex="20" role="radiogroup"
            [attr.aria-labelledby]="'medicarePartAEnrolledInd' + idx + '_label'">
            <label [id]="'medicarePartAEnrolledInd' + idx + '_label'" class="k-label">Part A (hospital)</label>
            <yes-no [name]="'medicarePartAEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
              (ngModelChange)="updateMedicarePartA($event)" [stretch]="false" [(ngModel)]="currentDependent.medicarePartAInd"
              [required]="selfPay.isRetireeInitial || selfPay.isCobraInitial"
              [disabled]="disableFormForNoCoverage"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline" *ngIf="selfPay.isSebbCobraInitial">
            <date-picker #medicarePartAEffectiveDate="ngModel" [name]="'medicarePartAEffectiveDate' + idx"
              [min]="currentDependent.birthDate"
              [required]="currentDependent.medicarePartAInd"
              [disabled]="disableFormForNoCoverage"
              [(ngModel)]="currentDependent.medicarePartADate">
              If yes, enter the effective date shown on the Medicare card
            </date-picker>
          </div>
        </div>
        <div fxLayout="row" fxFlexFill style="margin-top: 15px">
          <kendo-formfield [orientation]="'horizontal'" fxFlex="20" role="radiogroup"
            [attr.aria-labelledby]="'medicarePartBEnrolledInd' + idx + '_label'">
            <label [id]="'medicarePartBEnrolledInd' + idx + '_label'" class="k-label">Part B (medical)</label>
            <yes-no [name]="'medicarePartBEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
              (ngModelChange)="updateMedicarePartB($event)" [stretch]="false" [(ngModel)]="currentDependent.medicarePartBInd"
              [required]="selfPay.isRetireeInitial || selfPay.isCobraInitial"
              [disabled]="disableFormForNoCoverage"
              ></yes-no>
          </kendo-formfield>
          <div class="form-inline" *ngIf="selfPay.isSebbCobraInitial">
            <date-picker #medicarePartBEffectiveDate="ngModel" [name]="'medicarePartBEffectiveDate' + idx"
              [min]="currentDependent.birthDate"
              [required]="currentDependent.medicarePartBInd"
              [disabled]="disableFormForNoCoverage"
              [(ngModel)]="currentDependent.medicarePartBDate">
              If yes, enter the effective date shown on the Medicare card
            </date-picker>
          </div>
        </div>
        <div class="form-group" fxFill *ngIf="!selfPay.isSebbCobraInitial">
          <label for="suffix">Medicare number</label> <b *ngIf="!selfPay.isRetireeInitial" style="margin-left:5px;">Please verify the accuracy of your Medicare Beneficiary Number (MBI)</b>
          <input pattern="[a-zA-Z0-9]*" type="text" class="form-control" id="medicareNumber" name="medicareNumber"
            [(ngModel)]="currentDependent.medicareNumber" minlength="11" maxlength="12"
            [disabled]="disableFormForNoCoverage"
            />
        </div>
        <p style="margin-top: 20px" *ngIf="selfPay.isRetireeOE">
          If Yes, proof is required. Upload or mail a copy of all pages of their entire Medicare benefit verification
          letter or a copy of their Medicare card if we don't already have a copy. If mailing, write your last name and
          the last four digits of your Social Security Number on the copy so we can identify the account. Your dependent
          will not be enrolled until proof of Medicare is received. If your dependent is eligible for Medicare, they must
          enroll and stay enrolled in both Medicare Part A and Part B. Your dependent cannot be enrolled in separate Part D
          coverage if the selected plan includes drug coverage.
        </p>
        <p *ngIf="selfPay.isPebbCobraSOE">
          If Yes, proof is required. Upload or mail a copy of your Medicare benefit verification letter or a copy of your Medicare card.
          Write your full name and the last four digits of your Social Security number on the copy. You could face penalties if you don't
          enroll in Medicare Part A and Part B when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
        </p>
        <p *ngIf="selfPay.isPebbRetireeSOE">
          If Yes, proof is required. Upload or mail a copy of all pages of your Medicare benefit verification letter or a
          copy of your Medicare card if we don't already have a copy. If mailing, write your last name and
          the last four digits of your Social Security Number on the copy so we can identify your account. If you are
          eligible for Medicare, you must enroll and stay enrolled in both Medicare Part A
          and Part B to keep PEBB retiree health plan coverage.
        </p>
        <p *ngIf="selfPay.isPebbCobraInitial">
          If Yes, proof is required. Upload or mail a copy of their Medicare benefit verification letter or a copy of their Medicare card.
          Write your last name and the last four digits of your Social Security number on the copy so we can identify the account. Your spouse
          or SRDP will not be enrolled until their proof of Medicare is received. If they are eligible for Medicare, they must enroll and stay
          enrolled in both Medicare Part A and Part B. They cannot be enrolled in Separate Part D coverage if the selected plan includes drug coverage.
        </p>
        <p *ngIf="selfPay.isPebbCobraOE">
          If Yes, proof is required. Upload or mail a copy of their Medicare benefit verification letter or a copy of their Medicare card.
          Write your full name and the last four digits of your Social Security number on the copy. <b>Your dependent will not be enrolled until
          their proof of Medicare is received.</b> You could face penalties if you don't enroll in Medicare Part A and Part B when
          you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage. Your dependent cannot be enrolled in
          separate Part D coverage if the selected plan includes drug coverage.
        </p>
        <p *ngIf="selfPay.isSebbCobraOE">
          If Yes, proof is required. Upload or mail a copy of their Medicare benefit verification letter or a copy of their Medicare card.
          Write your full name and the last four digits of your Social Security number on the copy. <b>Your dependent will not be enrolled until
          their proof of Medicare is received.</b> You could face penalties if you don't enroll in Medicare Part A and Part B when
          you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
        </p>
        <p *ngIf="selfPay.isPebbRetireeInitial">
          If Yes, proof is required. Upload or mail a copy of all pages of their entire Medicare benefit verification letter or a copy of their Medicare
          card if we don't already have a copy. If mailing, write your last name and the last four digits of your Social Security Number on the copy
          so we can identify the account. If your dependent is eligible for Medicare, they must enroll and stay enrolled in both Medicare Part A and Part B.
          They cannot be enrolled in separate Part D coverage if the selected plan includes drug coverage.
        </p>
      </div>
      <div class="info" style="margin-bottom: 20px" *ngIf="!selfPay.isPebbCobraInitial">Premium surcharges do not apply if subscriber is enrolled in Medicare Part A and Part B</div>
    </div>
  </ng-template>
</form>
